(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Toggle html.is-scrolled when user scrolls past threshold.
  // Drives the runaway-nav.css state transitions.
  (function () {
    var html = document.documentElement;
    var threshold = 8;
    var current = null;
    function update() {
      var next = (window.scrollY || window.pageYOffset || 0) > threshold;
      if (next !== current) {
        current = next;
        html.classList.toggle('is-scrolled', next);
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runaway-field-reports"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(section) {
    var slides = section.querySelectorAll('[data-rwf-slide]');
    if (!slides.length) return;
    var card = section.querySelector('.rwf__card');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay = (parseFloat(section.getAttribute('data-rwf-autoplay')) || 0) * 1000;
    var i = 0;
    var timer = null;

    function fit(slide) {
      var q = slide.querySelector('.rwf__quote');
      if (!q) return;
      var cs = window.getComputedStyle(slide);
      var availW = slide.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (availW <= 0) return;
      var MAX = 64, MIN_ONE = 26;
      // Measure the quote's natural single-line width at a 100px reference.
      q.style.whiteSpace = 'nowrap';
      q.style.maxWidth = 'none';
      q.style.fontSize = '100px';
      var natW = q.scrollWidth || 1;
      var oneLine = Math.floor((100 * availW) / natW);
      if (oneLine >= MIN_ONE) {
        // Comfortable on a single line.
        q.style.whiteSpace = 'nowrap';
        q.style.fontSize = Math.min(MAX, oneLine) + 'px';
      } else {
        // Very long — let it wrap, but cap at ~two lines and the card height.
        q.style.whiteSpace = 'normal';
        q.style.maxWidth = availW + 'px';
        var size = Math.min(MAX, Math.round(oneLine * 1.9));
        q.style.fontSize = size + 'px';
        var lh = parseFloat(window.getComputedStyle(q).lineHeight) || size * 1.12;
        var guard = 0;
        while ((q.scrollHeight > lh * 2.2 || slide.scrollHeight > card.clientHeight) && size > 16 && guard < 50) {
          size -= 2;
          q.style.fontSize = size + 'px';
          lh = parseFloat(window.getComputedStyle(q).lineHeight) || size * 1.12;
          guard++;
        }
      }
    }

    var animating = false;
    function go(n, dir) {
      n = (n + slides.length) % slides.length;
      if (n === i || animating) return;
      var from = slides[i], to = slides[n];
      animating = true;
      // Place the incoming slide off-screen on the side it enters from, with no
      // transition, then force a reflow so the next change animates from there.
      to.style.transition = 'none';
      to.style.transform = 'translateX(' + (dir > 0 ? 100 : -100) + '%)';
      void to.offsetWidth;
      fit(to);
      to.style.transition = '';
      to.style.transform = 'translateX(0)';
      from.style.transform = 'translateX(' + (dir > 0 ? -100 : 100) + '%)';
      from.classList.remove('is-active');
      to.classList.add('is-active');
      i = n;
      window.setTimeout(function () { animating = false; }, 520);
    }

    function start() {
      if (reduce || delay <= 0 || slides.length < 2) return;
      timer = setInterval(function () { go(i + 1, 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    var prev = section.querySelector('[data-rwf-prev]');
    var next = section.querySelector('[data-rwf-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1, -1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1, 1); restart(); });
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);

    fit(slides[0]);
    window.addEventListener('load', function () { fit(slides[i]); });
    window.addEventListener('resize', function () { fit(slides[i]); });
    start();
  }
  document.querySelectorAll('[data-rwf]').forEach(setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runaway-lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(strip) {
    var down = false, sx = 0, sl = 0, moved = 0, lastX = 0, vx = 0, raf = null;
    function cancelGlide() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // let touch use native momentum scrolling
      cancelGlide();
      down = true; sx = e.clientX; lastX = e.clientX; sl = strip.scrollLeft; moved = 0; vx = 0;
      strip.classList.add('is-grabbing');
      try { strip.setPointerCapture(e.pointerId); } catch (_) {}
    });
    strip.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      vx = e.clientX - lastX;       // velocity = last frame's delta
      lastX = e.clientX;
      moved += Math.abs(vx);
      strip.scrollLeft = sl - dx;
    });
    function end(e) {
      if (!down) return;
      down = false;
      strip.classList.remove('is-grabbing');
      try { strip.releasePointerCapture(e.pointerId); } catch (_) {}
      // Fling: keep scrolling with the release velocity, decaying smoothly.
      var v = -vx * 14;
      if (Math.abs(v) < 2) return;
      (function glide() {
        strip.scrollLeft += v;
        v *= 0.92;
        raf = Math.abs(v) > 0.4 ? requestAnimationFrame(glide) : null;
      })();
    }
    strip.addEventListener('pointerup', end);
    strip.addEventListener('pointercancel', end);
    strip.addEventListener('lostpointercapture', end);
    strip.addEventListener('click', function (e) { if (moved > 6) e.preventDefault(); }, true);
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  document.querySelectorAll('[data-rlb-strip]').forEach(setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runaway-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Helper: returns true when a #RRGGBB / #RGB color is "dark"
    // enough that the Add-to-cart fill (which uses the variant
    // accent) would look indistinguishable from the darkened
    // Buy-it-now fill. Threshold tuned conservatively — Add to
    // cart reverts to outlined treatment below this.
    function isDarkHex(hex) {
      if (!hex) return false;
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
      if (hex.length < 6) return false;
      var r = parseInt(hex.substr(0, 2), 16);
      var g = parseInt(hex.substr(2, 2), 16);
      var b = parseInt(hex.substr(4, 2), 16);
      if (isNaN(r) || isNaN(g) || isNaN(b)) return false;
      var lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
      return lum < 0.25;
    }

    document.querySelectorAll('[data-runaway-product]').forEach(function (root) {
      var swatches = root.querySelectorAll('[data-runaway-swatch]');
      var variantInput = root.querySelector('[data-runaway-variant-input]');
      var priceEl = root.querySelector('[data-runaway-price]');
      var colorLabel = root.querySelector('[data-runaway-color-label]');
      var addLabel = root.querySelector('[data-runaway-add-label]');
      var galleries = root.querySelectorAll('[data-variant-gallery]');
      var addBtn = root.querySelector('[data-runaway-add-btn]');
      var buyBtn = root.querySelector('[data-runaway-buy-btn]');
      var mobileAddBtn = root.querySelector('[data-runaway-mobile-add]');
      var liveRegion = root.querySelector('[data-runaway-live]');

      // Respect the OS "reduce motion" accessibility setting:
      // scroll jumps become instant instead of animated.
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var scrollBehavior = reduceMotion ? 'auto' : 'smooth';

      // Apply dark-variant class on initial load based on the
      // active swatch's color (the swatch handler updates it
      // thereafter).
      var initialSwatch = root.querySelector('[data-runaway-swatch].is-selected');
      if (initialSwatch && isDarkHex(initialSwatch.dataset.variantHex)) {
        root.classList.add('runaway-product--dark-variant');
      }

      // Sticky mobile CTA: the bar appears when the in-page
      // Buy-it-now's TOP edge rises past the line 25% down the
      // screen (75% of the way UP — the button is near the top,
      // about to scroll out of view). Scrolling back re-hides at
      // the same line. rootMargin shrinks the observer root to
      // the top-25% band, so a threshold-0 crossing fires exactly
      // when the button's top passes the line (entering OR
      // leaving the band); show/hide is then resolved from the
      // rect, which is direction-proof.
      var stickyCta = root.querySelector('[data-runaway-mobile-cta]');
      var inPageBuyBtn = root.querySelector('.runaway-product__form .runaway-product__btn--buy');
      if (stickyCta && inPageBuyBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var line = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight * 0.25;
            var passed = entry.boundingClientRect.top <= line;
            stickyCta.classList.toggle('is-hidden', !passed);
            // If the bar hides while its color panel is open,
            // close the panel too (else the blur backdrop would
            // linger over the page).
            if (!passed && stickyCta.classList.contains('is-expanded')) {
              setCtaExpanded(false);
            }
          });
        }, { rootMargin: '0px 0px -75% 0px', threshold: [0] });
        io.observe(inPageBuyBtn);
      }

      // "Change Color" toggle — expands the sticky bar's color
      // panel and fades in a blur backdrop behind it.
      var ctaToggle = root.querySelector('[data-runaway-cta-toggle]');
      var ctaBackdrop = root.querySelector('[data-runaway-cta-backdrop]');

      function setCtaExpanded(expanded) {
        if (!stickyCta) return;
        stickyCta.classList.toggle('is-expanded', expanded);
        if (ctaBackdrop) ctaBackdrop.classList.toggle('is-visible', expanded);
        if (ctaToggle) {
          ctaToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          ctaToggle.textContent = expanded ? 'Close' : 'Change Color';
        }
      }

      if (ctaToggle && stickyCta) {
        ctaToggle.addEventListener('click', function () {
          setCtaExpanded(!stickyCta.classList.contains('is-expanded'));
        });
      }

      // Tap the backdrop → dismiss the panel.
      if (ctaBackdrop) {
        ctaBackdrop.addEventListener('click', function () {
          setCtaExpanded(false);
        });
      }

      // Mobile color-label value (inside the expandable panel).
      var mobileColorLabel = root.querySelector('[data-runaway-mobile-color-label]');

      // Quantity controls
      var qtyInput = root.querySelector('[data-runaway-qty-input]');
      var qtyMinus = root.querySelector('[data-runaway-qty-minus]');
      var qtyPlus = root.querySelector('[data-runaway-qty-plus]');
      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', function () {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
      }
      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', function () {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      }

      // AJAX add-to-cart → Dawn's cart notification/drawer instead
      // of a full page reload. Buy it now keeps its native submit
      // (name=checkout → straight to checkout). Falls back to the
      // native form post when no Dawn cart UI component exists or
      // the browser doesn't report which button submitted.
      var productFormEl = root.querySelector('[data-runaway-form]');
      var formError = root.querySelector('[data-runaway-form-error]');
      if (productFormEl && window.fetch) {
        productFormEl.addEventListener('submit', function (e) {
          if (!e.submitter || e.submitter.name === 'checkout') return;
          var cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cartUI || typeof cartUI.renderContents !== 'function') return;
          e.preventDefault();
          if (formError) formError.hidden = true;
          var fd = new FormData(productFormEl);
          if (typeof cartUI.getSectionsToRender === 'function') {
            fd.append('sections', cartUI.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          if (typeof cartUI.setActiveElement === 'function') {
            cartUI.setActiveElement(document.activeElement);
          }
          var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
          fetch(addUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status) {
                if (formError) {
                  formError.textContent = data.description || data.message || 'Could not add to cart.';
                  formError.hidden = false;
                }
                return;
              }
              cartUI.renderContents(data);
            })
            .catch(function () {
              if (formError) {
                formError.textContent = 'Could not add to cart. Please try again.';
                formError.hidden = false;
              }
            });
        });
      }

      // Gallery sliders — one per variant. Thumbs now live in
      // their own column (separate from gallery) so we look them
      // up by variant ID. Dots stay inside the gallery, used as
      // mobile pagination.
      galleries.forEach(function (g) {
        var variantId = g.dataset.variantGallery;
        var slider = g.querySelector('[data-runaway-slider]');
        var prev = g.querySelector('[data-runaway-prev]');
        var next = g.querySelector('[data-runaway-next]');
        var thumbsContainer = root.querySelector('[data-variant-thumbs="' + variantId + '"]');
        var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-runaway-thumb]') : [];
        var dots = g.querySelectorAll('[data-runaway-dot]');
        if (!slider) return;

        function scrollByCard(direction) {
          var slide = slider.querySelector('.runaway-product__slide');
          if (!slide) return;
          var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
          slider.scrollBy({ left: direction * (slide.offsetWidth + gap), behavior: scrollBehavior });
        }
        if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
        if (next) next.addEventListener('click', function () { scrollByCard(1); });

        function goToSlide(idx, instant) {
          var slides = slider.querySelectorAll('.runaway-product__slide');
          var slide = slides[idx];
          if (!slide) return;
          if (instant) {
            // Desktop thumb hover/click: jump STRAIGHT to the slide with
            // no smooth scroll — the image just appears, instead of the
            // slider cycling through every slide in between.
            var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
            slider.scrollTo({ left: idx * (slides[0].offsetWidth + gap), behavior: 'auto' });
          } else {
            slide.scrollIntoView({ behavior: scrollBehavior, block: 'nearest', inline: 'start' });
          }
        }

        // Desktop thumb rail: HOVER previews the image on the primary,
        // CLICK commits to it, and leaving the rail reverts to the
        // committed image. Every move is instant (no scroll animation).
        // (Thumbs are display:none on mobile, so this is desktop-only in
        // practice.)
        var committedThumb = 0;
        thumbs.forEach(function (thumb) {
          var thumbIdx = parseInt(thumb.dataset.runawayThumb, 10) || 0;
          thumb.addEventListener('mouseenter', function () {
            goToSlide(thumbIdx, true);
          });
          thumb.addEventListener('click', function () {
            committedThumb = thumbIdx;
            goToSlide(thumbIdx, true);
          });
        });
        if (thumbsContainer) {
          thumbsContainer.addEventListener('mouseleave', function () {
            goToSlide(committedThumb, true);
          });
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goToSlide(parseInt(dot.dataset.runawayDot, 10) || 0);
          });
        });

        // Sync thumb + dot active state with the slider's scroll
        // position. One scroll listener updates both.
        if (thumbs.length > 0 || dots.length > 0) {
          slider.addEventListener('scroll', function () {
            var firstSlide = slider.querySelector('.runaway-product__slide');
            if (!firstSlide) return;
            // Stride = slide width + flex gap (mobile card mode
            // has a 10px gap between peeking cards; 0 elsewhere).
            var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
            var idx = Math.round(slider.scrollLeft / (firstSlide.offsetWidth + gap));
            thumbs.forEach(function (t, i) {
              t.classList.toggle('is-active', i === idx);
            });
            dots.forEach(function (d, i) {
              d.classList.toggle('is-active', i === idx);
            });
          }, { passive: true });
        }
      });

      // Swatch click → switch variant
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var variantId = swatch.dataset.variantId;
          var hex = swatch.dataset.variantHex;
          var label = swatch.dataset.variantLabel;
          var price = swatch.dataset.variantPrice;
          var comparePrice = swatch.dataset.variantComparePrice;
          var available = swatch.dataset.variantAvailable === 'true';

          // Update form input
          if (variantInput) variantInput.value = variantId;

          // Update accent color CSS variable (drives swatch outline, button styles)
          root.style.setProperty('--runaway-product-accent', hex);

          // Toggle dark-variant treatment so the Add to cart and
          // Buy it now buttons stay visually distinguishable when
          // the accent is near-black.
          root.classList.toggle('runaway-product--dark-variant', isDarkHex(hex));

          // Update color label (desktop) AND the mobile color
          // value inside the sticky bar's Change Color panel.
          if (colorLabel) colorLabel.textContent = label;
          if (mobileColorLabel) mobileColorLabel.textContent = label;

          // Update price (+ Sale badge when discounted)
          if (priceEl) {
            var html = '<span class="runaway-product__price-current">' + price + '</span>';
            if (comparePrice) {
              html += '<span class="runaway-product__price-compare">' + comparePrice + '</span>';
              html += '<span class="runaway-product__price-badge">Sale</span>';
            }
            priceEl.innerHTML = html;
          }

          // CTA states: label + disabled on all three buttons
          if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
          if (addBtn) addBtn.disabled = !available;
          if (buyBtn) buyBtn.disabled = !available;
          if (mobileAddBtn) {
            // Sticky bar keeps the price on the label (the in-page
            // Add to cart stays plain). Re-apply on every swatch
            // change so switching color doesn't wipe the price.
            mobileAddBtn.textContent = available ? ('Add to cart · ' + price) : 'Sold out';
            mobileAddBtn.disabled = !available;
          }

          // Announce the change to screen readers (aria-live).
          if (liveRegion) {
            liveRegion.textContent = label + ' selected. ' + price + (available ? '' : '. Sold out');
          }

          // Active state on swatches — select EVERY swatch with
          // this variant id so the desktop swatches and the
          // duplicated mobile bar swatches stay in sync.
          swatches.forEach(function (s) {
            var isMatch = s.dataset.variantId === variantId;
            s.classList.toggle('is-selected', isMatch);
            s.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
          });

          // If the swatch came from the sticky bar's expand panel,
          // auto-collapse (panel + backdrop) after a short pause
          // so the user sees the active state update before the
          // panel slides shut.
          if (stickyCta && stickyCta.contains(swatch)) {
            setTimeout(function () { setCtaExpanded(false); }, 240);
          }

          // Swap visible gallery
          galleries.forEach(function (g) {
            var isActive = g.dataset.variantGallery === variantId;
            g.hidden = !isActive;
            g.classList.toggle('is-active', isActive);
          });

          // Swap visible thumbs column block (one per variant)
          var thumbBlocks = root.querySelectorAll('[data-variant-thumbs]');
          thumbBlocks.forEach(function (tb) {
            var isActive = tb.dataset.variantThumbs === variantId;
            tb.hidden = !isActive;
            tb.classList.toggle('is-active', isActive);
          });

          // (No auto-scroll on variant change — merchant call 2026-07-05:
          // the page must not jump when a colour is selected.)

          // Update URL with ?variant=<id> without reloading
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url.toString());
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runaway-scroll-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tracks = document.querySelectorAll('[data-rw-strip-track]');
  if (!tracks.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqMobile = window.matchMedia('(max-width: 749px)');

  var items = [];
  tracks.forEach(function (track) {
    var section = track.closest('.rw-strip');
    if (!section) return;
    var intD = parseFloat(track.style.getPropertyValue('--rw-strip-intensity')) || 1;
    var intM = parseFloat(track.style.getPropertyValue('--rw-strip-intensity-mobile'));
    if (isNaN(intM)) intM = intD;
    var it = {
      section: section,
      track: track,
      count: parseInt(track.getAttribute('data-rw-strip-count'), 10) || 1,
      intensityD: intD,
      intensityM: intM,
      loop: 0,
      travel: 0,   // scroll-driven offset
      drag: 0,     // accumulated manual swipe offset (persists, so panning resumes from here)
      dragging: false,
      pending: false,        // pointer is down but horizontal-intent not yet confirmed
      activePointerId: null, // only ONE pointer drives the drag (ignore extra fingers)
      startX: 0,
      startY: 0,
      lastX: 0,
      vx: 0,                 // recent drag velocity (px/frame) for the release glide
      lastT: 0,
      glide: null            // rAF id of the running glide animation
    };
    items.push(it);
    setupDrag(it);
  });

  // One "set" width = horizontal distance from the first card to the first card
  // of the 2nd copy. Robust to varied widths/gaps. Re-measured on resize/load.
  function measure() {
    items.forEach(function (it) {
      var cards = it.track.children;
      it.loop = cards.length > it.count ? (cards[it.count].offsetLeft - cards[0].offsetLeft) : 0;
    });
  }

  // Paint the track from its current scroll travel + manual drag, wrapped to one
  // set so it loops seamlessly in BOTH directions. Manual drag and scroll travel
  // feed the same offset, so after a swipe the scroll pan just continues from
  // where the finger/cursor left it.
  function render(it) {
    if (!it.loop) return;
    var base = it.travel - it.drag;
    var wrapped = ((base % it.loop) + it.loop) % it.loop;
    var x = -it.loop - wrapped;
    it.track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
  }

  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    items.forEach(function (it) {
      if (!it.loop) return;
      var rect = it.section.getBoundingClientRect();
      // Recompute scroll travel only when on-screen; keep last value otherwise.
      if (!(rect.bottom < -400 || rect.top > vh + 400)) {
        var p = (vh - rect.top) / (rect.height + vh);
        p = Math.max(0, Math.min(1, p));
        var intensity = mqMobile.matches ? it.intensityM : it.intensityD;
        it.travel = reduce ? 0 : p * it.loop * intensity;
      }
      render(it);
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  // ----- Click-drag (desktop) + swipe (mobile) -----
  // touch-action: pan-y (set in CSS) lets vertical page scroll through while we
  // capture horizontal drags. A drag to the right pulls the strip right; the
  // offset is added to `drag` and never reset, so scrolling resumes the pan from
  // the new position.
  function setupDrag(it) {
    var track = it.track;
    var THRESH = 7; // px of horizontal movement before we commit to a drag

    function down(e) {
      if (e.button != null && e.button > 0) return;   // ignore secondary mouse buttons (touch/pen = 0)
      if (it.activePointerId != null) return;          // a pointer is already driving; ignore extra fingers
      if (it.glide) { cancelAnimationFrame(it.glide); it.glide = null; }  // grabbing the strip stops a running glide
      it.activePointerId = e.pointerId != null ? e.pointerId : 'mouse';
      it.pending = true;     // wait to see if the gesture is horizontal before moving the strip
      it.dragging = false;
      it.vx = 0;
      it.lastT = performance.now();
      it.startX = e.clientX;
      it.startY = e.clientY;
      it.lastX = e.clientX;
      // Claim the pointer NOW, before deciding drag-vs-scroll. If we wait until
      // ~7px of horizontal travel (the old behaviour) the browser can already
      // have grabbed the gesture for its back/forward edge-swipe — which is why
      // the swipe only worked one way. Vertical page scroll is unaffected:
      // touch-action: pan-y lets the browser scroll and fire pointercancel,
      // which releases us. If the gesture turns out vertical we release below.
      if (track.setPointerCapture && e.pointerId != null) {
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
      }
    }
    function release(e) {
      if (track.releasePointerCapture && e && e.pointerId != null) {
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
      }
    }
    function move(e) {
      var pid = e.pointerId != null ? e.pointerId : 'mouse';
      if (it.activePointerId == null || pid !== it.activePointerId) return;
      if (it.pending) {
        var dxs = e.clientX - it.startX;
        var dys = e.clientY - it.startY;
        if (Math.abs(dxs) < THRESH && Math.abs(dys) < THRESH) return; // not enough movement yet
        if (Math.abs(dys) > Math.abs(dxs)) {
          // Vertical intent — hand the gesture back so native page scroll runs.
          it.pending = false;
          it.activePointerId = null;
          release(e);
          return;
        }
        // Horizontal intent — start dragging (pointer already captured in down()).
        it.pending = false;
        it.dragging = true;
        it.lastX = e.clientX;
        track.classList.add('rw-strip__track--grabbing');
      }
      if (!it.dragging) return;
      if (e.cancelable) e.preventDefault();   // we own this gesture now — block any residual browser handling
      var dx = e.clientX - it.lastX;
      it.lastX = e.clientX;
      it.drag += dx;
      // Velocity estimate (px per ~frame), smoothed so one jittery event
      // doesn't dictate the glide.
      var now = performance.now();
      var dt = Math.max(1, now - it.lastT);
      it.lastT = now;
      it.vx = 0.75 * it.vx + 0.25 * (dx / dt) * 16.7;
      render(it);
    }
    function endDrag(e) {
      var pid = e && e.pointerId != null ? e.pointerId : 'mouse';
      if (it.activePointerId != null && pid !== it.activePointerId) return; // not the active pointer
      var wasDragging = it.dragging;
      it.dragging = false;
      it.pending = false;
      it.activePointerId = null;
      track.classList.remove('rw-strip__track--grabbing');
      release(e); // always release — we now capture on pointerdown, even for taps/vertical that never became a drag
      // Fluid release: keep coasting from the flick velocity, decaying each
      // frame (matches the lookbook's native momentum feel). Friction 0.95
      // ≈ a gentle ~1s glide from a strong flick.
      if (wasDragging && Math.abs(it.vx) > 0.5) {
        var step = function () {
          it.vx *= 0.95;
          if (Math.abs(it.vx) < 0.3) { it.glide = null; return; }
          it.drag += it.vx;
          render(it);
          it.glide = requestAnimationFrame(step);
        };
        it.glide = requestAnimationFrame(step);
      }
    }
    track.addEventListener('pointerdown', down);
    track.addEventListener('pointermove', move, { passive: false });
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); }); // no native image drag
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
  window.addEventListener('load', function () { measure(); update(); });
  measure();
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runaway-story-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Pin the hero height in pixels so it NEVER reacts to the mobile address
  // bar hiding/showing on scroll (which made the banner visibly expand).
  // svh was meant to keep it stable, but on some mobile browsers the bar
  // collapse still grows it. We lock to innerHeight on load and only re-lock
  // when the WIDTH changes (rotation) on touch devices — never on the
  // height-only resizes the URL bar fires. The CSS keeps `100svh` as the
  // no-JS fallback.
  function lock() {
    var vh = window.innerHeight;
    var heroes = document.querySelectorAll('.runaway-story-hero');
    for (var i = 0; i < heroes.length; i++) {
      heroes[i].style.setProperty('--rw-hero-vh', vh + 'px');
    }
  }
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var lastW = window.innerWidth;
  lock();
  window.addEventListener('resize', function () {
    // Desktop: track all resizes. Touch: only re-lock on width change
    // (orientation), ignore URL-bar height-only resizes.
    if (!coarse || window.innerWidth !== lastW) {
      lastW = window.innerWidth;
      lock();
    }
  }, { passive: true });
  window.addEventListener('orientationchange', lock);
})();

  } catch(e) { console.error(e); }
})();
})();
